export const ATTRIBUTES = {
    CURRENT_STEP: 'current-step',
    TOTAL_STEPS: 'total-steps',
};

export const GEOMETRY = {
    RADIUS: 57,
};
